import React, { useState } from 'react';
import { Trophy, ChevronRight } from 'lucide-react';
import records from '../data/pointlessRecords.json';
import LikeButton from './LikeButton';
import ShareButton from './ShareButton';

const PointlessRecords = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const generateNewRecord = () => {
    setCurrentIndex((prev) => (prev + 1) % records.records.length);
  };

  const record = records.records[currentIndex];

  return (
    <div className="card hover-lift p-6 group">
      <div className="flex items-center space-x-2 mb-6">
        <div className="p-2 rounded-lg bg-gradient-to-br from-purple-500/20 to-pink-500/20 group-hover:from-purple-500/30 group-hover:to-pink-500/30 transition-colors">
          <Trophy className="h-6 w-6 text-purple-400" />
        </div>
        <h3 className="text-xl font-semibold gradient-text">Pointless Records</h3>
      </div>
      <div className="space-y-6">
        <div className="bg-gradient-to-br from-purple-500/5 to-pink-500/5 rounded-lg p-4">
          <h4 className="text-lg font-semibold text-white mb-2">{record.title}</h4>
          <p className="text-gray-300 leading-relaxed mb-4">{record.description}</p>
          <div className="text-sm text-purple-300">
            Record: {record.record}
          </div>
          <div className="text-sm text-gray-400 mt-2">
            Holder: {record.holder} ({record.year})
          </div>
        </div>
        <div className="flex justify-between items-center text-sm">
          <div className="flex items-center space-x-2">
            <LikeButton type="record" content={record.title} />
            <ShareButton 
              title="Check out this pointless record!"
              text={`${record.title}: ${record.description} (Record: ${record.record} by ${record.holder}, ${record.year})`}
            />
          </div>
          <button 
            onClick={generateNewRecord}
            className="text-purple-400 hover:text-purple-300 transition flex items-center space-x-1 group"
          >
            <span>Next Record</span>
            <span className="transform group-hover:translate-x-1 transition-transform">→</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PointlessRecords;